import type { IAction } from '../services/Api';

/**
 * Central registry of all API actions — mirrors ApiActionList from the mobile repo.
 * Each entry owns its endpoint URL and the phi-* audit header values.
 */
export const ApiActionList: Record<string, IAction> = {
  // ── Chat Service ────────────────────────────────────────────────────────────
  CHAT_FETCH_INBOX_MESSAGES: {
    Type: 'View',
    Description: 'Fetch Inbox Messages',
    Name: 'fetchInboxMessages',
    Url: () => '/chat/inbox',
  },
  CHAT_GET_CHATROOM_MESSAGES: {
    Type: 'View',
    Description: 'Get Chatroom Messages',
    Name: 'getChatroomMessages',
    Url: () => '/chat/chatroom/messages',
  },
  CHAT_GET_CHATROOM_PARTICIPANTS: {
    Type: 'View',
    Description: 'Get Chatroom Participants',
    Name: 'getChatroomParticipants',
    Url: () => '/chat/chatroom/participants',
  },
  CHAT_UPDATE_MESSAGE_STATUS: {
    Type: 'Save',
    Description: 'Update Message Status',
    Name: 'updateMessageStatus',
    Url: () => '/chat/chatroom/update-message-status',
  },
  PIN_CHAT: {
    Type: 'Save',
    Description: 'Pin Chatroom',
    Name: 'pinChatroom',
    Url: () => '/chat/chatroom/pin',
  },
  CHAT_LEAVE_CONVERSATION: {
    Type: 'Save',
    Description: 'Leave Conversation',
    Name: 'archiveChatroom',
    Url: () => '/chat/chatroom/archieve',
  },
  CHAT_RENAME_CHATROOM: {
    Type: 'Save',
    Description: 'Rename Chatroom',
    Name: 'renameChatroom',
    Url: () => '/chat/chatroom/renameChatroom',
  },
  GET_STAFF_FACILITIES: {
    Type: 'View',
    Description: 'Get Staff Facilities',
    Name: 'getStaffFacilities',
    Url: () => '/chat/staff/facilities',
  },
  GET_STAFF_PARTICIPANTS: {
    Type: 'View',
    Description: 'Get Staff Participants',
    Name: 'getStaffParticipants',
    Url: () => '/chat/staff/participants',
  },
  VALIDATE_CHAT_PARTICIPANT: {
    Type: 'Save',
    Description: 'Validate Chat Participant',
    Name: 'validateChatParticipant',
    Url: () => '/chat/chatroom/validate-participant',
  },
  CREATE_CHATROOM: {
    Type: 'Save',
    Description: 'Create Chatroom',
    Name: 'createChatroom',
    Url: () => '/chat/chatroom/create',
  },
  ADD_CHATROOM_PARTICIPANT: {
    Type: 'Save',
    Description: 'Add Chatroom Participant',
    Name: 'addChatroomParticipant',
    Url: () => '/chat/chatroom/add-participant',
  },
};
